'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

exports.groupFactory = groupFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsClone = require('./utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var Group = (function () {
  function Group() {
    var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Group);

    this.groupByTree = obj.groupByTree || { _id: '0' };
  }

  _createClass(Group, [{
    key: 'sum',
    value: function sum(fieldName) {
      return this._addAccumulator('sum', fieldName);
    }
  }, {
    key: 'avg',
    value: function avg(fieldName) {
      return this._addAccumulator('avg', fieldName);
    }
  }, {
    key: 'min',
    value: function min(fieldName) {
      return this._addAccumulator('min', fieldName);
    }
  }, {
    key: 'max',
    value: function max(fieldName) {
      return this._addAccumulator('max', fieldName);
    }
  }, {
    key: 'count',
    value: function count() {
      var groupByTree = (0, _utilsClone2['default'])(this.groupByTree);
      var accFieldName = 'count';
      var accumulator = { '$sum': 1 };
      groupByTree[accFieldName] = accumulator;
      return this._copy(groupByTree);
    }
  }, {
    key: '_build',
    value: function _build() {
      return this.groupByTree;
    }
  }, {
    key: '_addAccumulator',
    value: function _addAccumulator(acc, fieldName) {
      var groupByTree = (0, _utilsClone2['default'])(this.groupByTree);
      var accFieldName = fieldName + capitalize(acc);
      var accumulator = {};
      accumulator['$' + acc] = '$' + fieldName;
      groupByTree[accFieldName] = accumulator;
      return this._copy(groupByTree);
    }
  }, {
    key: '_copy',
    value: function _copy(groupByTree) {
      return new this.constructor(Object.assign({}, this, { groupByTree: groupByTree }));
    }
  }]);

  return Group;
})();

exports.Group = Group;

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function groupFactory() {
  for (var _len = arguments.length, fieldName = Array(_len), _key = 0; _key < _len; _key++) {
    fieldName[_key] = arguments[_key];
  }

  if (fieldName.length === 1) {
    return groupWithId('$' + fieldName);
  } else if (fieldName.length > 1) {
    var _ret = (function () {
      var _id = {};
      fieldName.forEach(function (field) {
        return _id[field] = '$' + field;
      });
      return {
        v: groupWithId(_id)
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else {
    return new Group();
  }
}

function groupWithId(_id) {
  return new Group({ groupByTree: { _id: _id } });
}